module.exports = __webpack_public_path__ + "b5c1cccd05cf9175bc5fdb2c531447f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/otherPay_inactive.png
// module id = 296
// module chunks = 0